
import React from 'react';
import { Navigation } from '../layout/Navigation';
import { Sidebar } from '../layout/Sidebar';
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { useNavigate } from 'react-router-dom';
import { BloombergRadioButton } from '../trading/BloombergRadioButton';
import { ComplianceHeader } from './ComplianceHeader';
import { ComplianceTabsList } from './ComplianceTabsList';
import { OverviewTab } from './tabs/OverviewTab';
import { DisclosuresTab } from './tabs/DisclosuresTab';
import { ReportsTab } from './tabs/ReportsTab';
import CommunicationsMonitor from './CommunicationsMonitor';

export const Compliance = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState('overview');
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const refreshData = () => {
    setIsRefreshing(true);
    // Simulate data refresh
    setTimeout(() => {
      setIsRefreshing(false);
    }, 1500);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation 
        activeView="chat"
        setActiveView={() => {}}
        showRoles={false}
        setShowRoles={() => {}}
      />
      <div className="flex">
        <div className="hidden md:block">
          <Sidebar />
        </div>
        
        <div className="flex-1 p-6">
          <div className="max-w-7xl mx-auto">
            <ComplianceHeader 
              refreshData={refreshData} 
              isRefreshing={isRefreshing} 
            />

            <Tabs defaultValue="overview" value={activeTab} onValueChange={setActiveTab}>
              <ComplianceTabsList activeTab={activeTab} />

              <TabsContent value="overview">
                <OverviewTab />
              </TabsContent>

              <TabsContent value="communications">
                <CommunicationsMonitor />
              </TabsContent>

              <TabsContent value="disclosures">
                <DisclosuresTab />
              </TabsContent>

              <TabsContent value="reports">
                <ReportsTab />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
      
      <BloombergRadioButton />
    </div>
  );
};
